import React, { useState } from "react";
import { postRequest } from "../utils/api";
import { useConfig } from "../utils/use-config";
import { useCustomer } from "../utils/use-customer";
import Input from "./Input";
import SubmitButton from "./SubmitButton";

type Props = {};

const CustomerForm: React.FC<Props> = ({}) => {
  const { publishableKey } = useConfig();
  const { setCustomer } = useCustomer();
  const [submitting, setSubmitting] = useState(false);
  const [form, setForm] = useState({ email: "", first_name: "" });
  const [errors, setErrors] = useState<Record<string, string>>({});

  return (
    <form
      className="hw-flex hw-flex-col hw-items-end"
      onSubmit={async (e) => {
        e.preventDefault();

        setSubmitting(true);

        const resp = await postRequest(publishableKey, "/customers", form);
        const json = await resp.json();

        setSubmitting(false);

        if (resp.status < 300) {
          setCustomer(json.jwt);
        } else {
          console.log("Form errors", json);
          setErrors(json.validation_errors);
        }
      }}
    >
      <p className="hw-w-full hw-text-sm hw-text-gray-600 hw-mb-3">
        To start we need your contact details so we can respond to your enquiry.
      </p>
      <div className="hw-w-full">
        <label
          htmlFor="name"
          className="hw-block hw-text-sm hw-font-medium hw-text-gray-700"
        >
          Your name
        </label>
        <div className="hw-mt-1">
          <Input
            type="text"
            name="name"
            id="name"
            value={form.first_name}
            onChange={(e) => setForm({ ...form, first_name: e.target.value })}
            placeholder="Jenifer Baker"
            error={errors.first_name}
          />
        </div>
      </div>

      <div className="hw-w-full hw-mt-3">
        <label
          htmlFor="email"
          className="hw-block hw-text-sm hw-font-medium hw-text-gray-700"
        >
          Email address
        </label>
        <div className="hw-mt-1">
          <Input
            type="email"
            name="email"
            id="email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            placeholder="jenifer.baker@example.com"
            error={errors.email}
          />
        </div>
      </div>

      <SubmitButton text="Next" disabled={submitting} />
    </form>
  );
};

export default CustomerForm;
